import { MutableRefObject } from 'react';
import {
  DOWN_ARROW,
  ENTER_KEY,
  KeyCode,
  LEFT_ARROW,
  RIGHT_ARROW,
  SPACE_KEY,
  UP_ARROW,
} from 'constants/keyCodes';

export const TEMPLATE_SELECTOR_ROW_COUNT = 3;

export const useContentTemplateSelectorKeyPress = () => {
  const handleKeyPress = (
    { keyCode }: { keyCode: KeyCode },
    refs: MutableRefObject<HTMLDivElement[] | null[]>,
  ) => {
    try {
      const focusedIndex = refs.current.findIndex((opt) => opt === document.activeElement);
      const isItemFocused = focusedIndex > -1;
      const focusedItem = refs.current[focusedIndex];
      const rows = Math.ceil(refs.current.length / TEMPLATE_SELECTOR_ROW_COUNT);
      const focusedRow = isItemFocused
        ? Math.floor(focusedIndex / TEMPLATE_SELECTOR_ROW_COUNT) + 1
        : 0;

      switch (keyCode) {
        case UP_ARROW: {
          if (isItemFocused && focusedIndex >= TEMPLATE_SELECTOR_ROW_COUNT) {
            refs.current[focusedIndex - 3]?.focus();
          }
          break;
        }

        case DOWN_ARROW: {
          if (isItemFocused && focusedRow < rows) {
            refs.current[focusedIndex + 3]?.focus();
          }
          break;
        }

        case RIGHT_ARROW: {
          if (
            isItemFocused &&
            focusedIndex % TEMPLATE_SELECTOR_ROW_COUNT !== TEMPLATE_SELECTOR_ROW_COUNT - 1 &&
            focusedIndex < refs.current.length - 1
          ) {
            refs.current[focusedIndex + 1]?.focus();
          }
          break;
        }

        case LEFT_ARROW: {
          if (isItemFocused && focusedIndex % TEMPLATE_SELECTOR_ROW_COUNT > 0) {
            refs.current[focusedIndex - 1]?.focus();
          }
          break;
        }

        case SPACE_KEY:
        case ENTER_KEY: {
          focusedItem?.click();
          break;
        }

        default: {
          return;
        }
      }
    } catch (err) {
      console.error(err); // eslint-disable-line
    }
  };

  return handleKeyPress;
};
